module.exports = __webpack_public_path__ + "static/media/teapp_logo_orange.451bcd18.svg";